import { useSelector } from 'react-redux'
import get from 'lodash/get'

const useJsonApiIsLoading = (endpoint) => {
  const isLoading = useSelector(state => get(state, ['apiMeta', 'status', endpoint, 'type']) === 'API_WILL_READ')
  return isLoading
};

export default useJsonApiIsLoading
